import * as Common from '@/tenantCatalog/common';

export class OptionPricing extends Common.StateObject{
  constructor(){
    super('OptionPricing')
    this.optionFlag = 0;
    this.state = Common.ApprovalStatus.NotApproved;  
    this.workflowStateId = Common.ApprovalStatus.NotApproved;  
  }
  public optionFlag : number;
  public description : string = '';
  public optionPrice : number;
}

export class OptionPricingQuery extends Common.LoadQuery {
  constructor(){
    super('OptionPricingQuery',OptionPricing);
    this.sort = 'optionFlag';    
  }
}